export const MAX_GRID_THUMBNAILS = 4;

export const THUMBNAIL_SIZES = '(min-width: 1280px) 427px, 33vw';

interface PhotoGridLayout {
  gridClassName: string;
  mainClassName: string;
  mainSizes: string;
  thumbnails: { className: string }[];
}

/**
 * Desktop photo grid (shown from `md`): two fixed-height rows, main photo on
 * the left. Each layout fills the explicit cells exactly at both `md` and `lg`,
 * because a tile auto-placed into an implicit row gets zero height and vanishes.
 * `layout-bounds` caps the content width at 1280px, which the sizes reflect.
 */
export function getPhotoGridLayout(thumbnailCount: number): PhotoGridLayout {
  const count = Math.min(thumbnailCount, MAX_GRID_THUMBNAILS);

  if (count === 0) {
    return {
      gridClassName: 'grid-cols-1',
      mainClassName: 'row-span-2',
      mainSizes: '(min-width: 1280px) 1280px, 100vw',
      thumbnails: []
    };
  }

  if (count <= 2) {
    return {
      gridClassName: 'grid-cols-3',
      mainClassName: 'col-span-2 row-span-2',
      mainSizes: '(min-width: 1280px) 853px, 66vw',
      thumbnails: count === 1 ? [{ className: 'row-span-2' }] : [{ className: '' }, { className: '' }]
    };
  }

  // 3–4 thumbnails: two stacked in a third column below `lg`, a 2×2 block from `lg`.
  return {
    gridClassName: 'grid-cols-3 lg:grid-cols-4',
    mainClassName: 'col-span-2 row-span-2',
    mainSizes: '(min-width: 1280px) 640px, (min-width: 1024px) 50vw, 66vw',
    thumbnails:
      count === 3
        ? [{ className: 'lg:row-span-2' }, { className: '' }, { className: 'hidden lg:block' }]
        : [{ className: '' }, { className: '' }, { className: 'hidden lg:block' }, { className: 'hidden lg:block' }]
  };
}
